import { RegisterCard } from "../components/RegisterCard";
import { TopAdminNav } from "../layouts/TopAdminNav";
import "../assets/css/main.css";
import "../assets/css/student.css";
import { useEffect, useState } from "react";
import useWindowDimensions from "../hooks/useWindowSize";
import toast from "react-hot-toast";
import { defaultUrl } from "../features/actions";
import { makeFetchRequest } from "../utilities/common";
import { StudentDataInterface } from "../types/interfaces";
import RenderStudentList from "./staff_components/staff_student_data/StudentList";
import StudentListInput from "./staff_components/staff_student_data/StudentListInput";

export const StaffStudentData = () => {
  const { width: windowWidth } = useWindowDimensions();
  const isMobileScreen = windowWidth < 440;

  useEffect(() => {
    const searchBar = document.getElementById("searchAttendanceInput");
    searchBar?.focus();
    toast.remove();
    toast.loading("loading pupil data...");
    fetchStudentData();
    toast.remove();
    toast.success("loading complete");
  }, []);

  /** DATA FETCHING */
  const [studentData, setStudentData] = useState<StudentDataInterface[]>([]);
  const [classes, setClasses] = useState<any>();

  const fetchStudentData = async () => {
    const response = await makeFetchRequest(
      `${defaultUrl}/students/withoutPagination`,
    );
    const students =
      response &&
      response.map((student: any) => {
        return {
          ...student,
          profile_picture: (
            <img
              style={{ height: "100%", width: "100%" }}
              src={student.profile_picture}
              alt="pupil"
            />
          ),
        };
      });
    const classroomsData = await makeFetchRequest(`${defaultUrl}/classroom`);
    setStudentData(students);
    setClasses(classroomsData);
  };

  /** FILTERINGS **/
  const [searchTerm, setSearchTerm] = useState("");
  const [classRoomFilter, setClassRoomFilter] = useState("");
  const [filteredData, setFilteredData] = useState(studentData);

  useEffect(() => {
    setFilteredData(filterData());
  }, [studentData, searchTerm, classRoomFilter]);

  function filterData() {
    const filtered =
      studentData &&
      studentData
        .filter((data) => {
          if (!searchTerm.length) {
            return data;
          }
          const fullName = `${data.firstname} ${data.othername} ${data.surname}`;
          return fullName.toLowerCase().includes(searchTerm.toLowerCase());
        })
        .filter((data) => {
          if (!classRoomFilter.length) {
            return data;
          }

          return (
            data.classroom?.name.toLowerCase() === classRoomFilter.toLowerCase()
          );
        });
    return filtered;
  }

  return (
    <div className="min-h-screen bg-[#F8FAFC] p-4 md:p-8 flex flex-col space-y-6 text-left">
      {/* Platform Header Container */}
      <div className="w-full flex items-center">
        <TopAdminNav name="Jane Doe" title="Pupil Directory" />
      </div>

      {/* Main Base Card Workspace */}
      <div className="bg-white border border-gray-100 rounded-3xl shadow-xs overflow-hidden flex flex-col flex-1">
        {/* Module Title Banner Deck */}
        <div className="w-full">
          <RegisterCard
            title="Pupil Information Hub"
            details="View comprehensive profiles, structural developmental traces, and timeline actions for current student rosters."
          />
        </div>

        {/* Workspace Canvas Filter Input row */}
        <div className="px-6 py-4 bg-slate-50/50 border-b border-gray-100">
          <StudentListInput
            mobileScreen={isMobileScreen}
            onChange={(e: any) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Reactive Student List Data Table Box */}
        <div
          className={`text-[#012063CC] flex-1 overflow-hidden ${
            isMobileScreen
              ? "px-4 overflow-y-auto !pb-[80px] h-[65vh]"
              : "p-6 flex flex-col"
          }`}
        >
          {isMobileScreen ? (
            <RenderStudentList
              data={filteredData}
              data2={classes}
              mobilescreen={isMobileScreen}
            />
          ) : (
            <div className="w-full flex-1 flex flex-col overflow-hidden">
              {/* Premium Standardized Formatted Table Headers */}
              <div className="grid grid-cols-12 w-full mb-3 py-3 px-6 bg-[#F4F7FE] text-[#012063] font-bold text-xs tracking-wider uppercase rounded-xl border border-gray-200/50 items-center text-left">
                <div className="col-span-2 pl-3">Avatar</div>
                <div className="col-span-4">Full Student Name</div>
                <div className="col-span-2 text-center">Date of Birth</div>
                <div className="col-span-2 text-center">Assigned Classroom</div>
                <div className="col-span-2 text-right pr-4">Action Gateway</div>
              </div>

              {/* Scrollable Data Body Section Container */}
              <div className="flex-1 overflow-y-auto pr-1 register-scroll max-h-[55vh] pb-8">
                {filteredData && filteredData.length > 0 ? (
                  <RenderStudentList
                    data={filteredData}
                    data2={classes}
                    mobilescreen={isMobileScreen}
                  />
                ) : (
                  <div className="text-center py-16 text-slate-400 font-medium text-xs italic border border-dashed border-slate-200 rounded-2xl bg-white">
                    No active student catalog records matched your dynamic
                    lookup criteria...
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
